<template>
	
	<component :is="validationWrapper" :class="validationClasses">
		<slot></slot>

		<p 
			v-if="validationShow" 
			class="c-validation-message__message" 
		>
			<svg 
				class="c-validation-message__icon" 
				:class="validationSVGClasses"
				aria-hidden="true" focusable="false"
			>
			
				<use 
					v-if="valid"
					xmlns:xlink="http://www.w3.org/1999/xlink" 
					xlink:href="#tick-1"
				></use>
				<use 
					v-else-if="invalid"
					xmlns:xlink="http://www.w3.org/1999/xlink" 
					xlink:href="#cross"
				></use>
			</svg>
			<span v-html="validationMessage"></span>
		</p>

	</component>	

</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		valid: {
			type: Boolean,
			default: null,
		},
		invalid: {
			type: Boolean,
			default: null,
		},
		validationMessage: {
			required: false,
			type: String,
		},
	},

	computed: {
		validationShow() {
			return this.valid || this.invalid ? true : false;
		},
		validationWrapper() {
			return this.validationShow ? "div" : "fragment";
		},
		validationClasses() {
			if (this.validationShow) {
				return `c-validation-message c-validation-message--is-${
					this.valid ? "valid" : "invalid"
				}`;
			}
		},
		validationSVGClasses() {
			return this.invalid
				? "c-validation-message__icon--invalid"
				: "c-validation-message__icon--valid";
		}
	},
	watch: {
		valid(newValue) {
			if (newValue) {
				this.invalid = false;
			}
		},
		invalid(newValue) {
			if (newValue) {
				this.valid = false;
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/base/validation-message/ValidationMessage.vue